export enum Direction {
    Home = "assets/img/homeHero.jpg",
    Search = "assets/img/searchHero.jpg"
  }